import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import * as Sentry from "@sentry/react";
import { UserAccount } from "../../types/types";

const initialState = {
  accounts: [] as UserAccount[],
  accountSelected: null as UserAccount | null,
  accountInitialized: false,
  balanceRefetchTrigger: 0,
};

const userAccountsSlice = createSlice({
  name: "userAccounts",
  initialState,
  reducers: {
    updateAccounts: (state, action: PayloadAction<UserAccount[]>) => {
      state.accounts = action.payload;
    },
    updateAccountSelected: (state, action: PayloadAction<UserAccount>) => {
      state.accountSelected = action.payload;
      state.accountInitialized = true;
      Sentry.setTag("account.number", action.payload.number);
      Sentry.setTag("account.name", action.payload.name);
      Sentry.setContext("account", {
        number: action.payload.number,
        name: action.payload.name,
      });
      Sentry.addBreadcrumb({
        category: "account",
        message: "Account switched",
        level: "info",
        data: { number: action.payload.number, name: action.payload.name },
      });
    },
    resetAccounts: (state) => {
      state.accounts = [];
    },
    triggerBalanceRefetch: (state) => {
      state.balanceRefetchTrigger += 1;
    },
  },
});

export const {
  updateAccounts,
  updateAccountSelected,
  resetAccounts,
  triggerBalanceRefetch,
} = userAccountsSlice.actions;
export default userAccountsSlice.reducer;
